import { computed } from 'vue'

import { useCookie, useState } from '#imports'

import {
  APPEARANCE_COOKIE_NAME,
  appearanceCookieOptions,
  normalizeAppearance,
} from '@baserow/modules/core/utils/appearance'

/**
 * The selected appearance intentionally belongs to the browser, not to the user
 * account. Keeping it in a cookie lets Nuxt render the correct theme on the
 * server before the application hydrates.
 */
export const useAppearance = () => {
  const cookie = useCookie(APPEARANCE_COOKIE_NAME, appearanceCookieOptions)
  const appearance = useState('canis-appearance', () =>
    normalizeAppearance(cookie.value)
  )

  const setAppearance = (value) => {
    const normalizedValue = normalizeAppearance(value)
    appearance.value = normalizedValue
    cookie.value = normalizedValue
  }

  return {
    appearance: computed(() => appearance.value),
    setAppearance,
  }
}
